const profile = [
	'Animador',
	'Arquitecto',
	'Artista 3D',
	'Artista Digital',
	'Diseñador Grafico',
	'Diseñador industrial',
	'Estudiante de Colegio',
	'Estudiante de universidad',
	'Ilustrador',
	'Ingeniero de sistemas',
	'Ingeniero Multimedia',
	'Profesional en cine y animación',
	'Publicista',
	'Otro',
];

export const software = [
	{ value: 'zbrush', label: 'ZBrush' },
	{ value: 'blender', label: 'Blender' },
	{ value: 'maya', label: 'Maya' },
	{ value: 'unity', label: 'Unity' },
	{ value: 'unreal_engine', label: 'Unreal Engine' },
	{ value: 'character_creator', label: 'Character Creator (CC)' },
	{ value: 'iclone', label: 'Iclone' },
	{ value: 'substance_painter', label: 'Substance Painter' },
	{ value: 'photoshop', label: 'Photoshop' },
	{ value: 'marmoset', label: 'Marmoset' },
	{ value: '3ds_max', label: '3Ds Max' },
	{ value: 'houdini', label: 'Houdini' },
	{ value: 'cinema_4d', label: 'Cinema 4D' },
	{ value: 'clip_studio_paint', label: 'Clip Studio Paint' },
	{ value: 'meshmixer_onshape', label: 'Meshmixer / Onshape' },
	{ value: 'solidworks', label: 'SolidWorks' },
	{ value: 'sketchup', label: 'Sketchup' },
	{ value: 'rhinoceros', label: 'Rhinoceros' },
	{ value: 'otros', label: 'Otros' },
	{ value: 'ninguno', label: 'Ninguno' },
];

export const porfolio = [
	'Sí, listo para revisión',
	'En proceso / No organizado',
	'No tengo todavía',
];

export const experience = [
	'Avanzado (Uso profesional)',
	'Intermedio (Tengo las bases)',
	'Principiante (Desde cero)',
];

export const inversion = [
	'Especialización Máster ($1,100 USD en adelante)',
	'Entrenamiento avanzado ($800 USD)',
	'Formación técnica ($500 USD)',
	'Curso de iniciación ($300 USD)',
];

export default profile;
